/* eslint-disable no-throw-literal */
/* eslint-disable no-unused-vars */
import client from '../../Components/Client';
import service from './service';
import serviceTwo from './serviceTwo';

export const getPlans = async (page, pageSize) => {
  const response = await service.get(`/subscription-plans?page=${page}&pageSize=${pageSize}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw new Error(`Unable to get plans. ${response.statusText}`);
};

export const getPlan = async (planId) => {
  if (!planId) return undefined;

  const response = await service.get(`/subscription-plans/${planId}`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to get plans. ${response.statusText}`;
};

export const createPlan = async (plan) => {
  const response = await service.post('/subscription-plans', plan);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to create plan. ${response.statusText}`;
};

export const updatePlan = async (plan) => {
  const response = await service.put(`/subscription-plans/${plan.id}`, plan);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  throw `Unable to update the plan. ${response.statusText}`;
};

export const getPlanMenu = async () => {
  const response = await service.get('/subscription-plans?pageSize=100');

  if (response.status === 200) {
    const data = response.data;

    return (data?.items ?? []).map((plan) => ({
      label: plan.name,
      value: plan.id,
    }));
  }

  throw `Unable to get plans. ${response.statusText}`;
};

const remove = async (id) => {
  const response = await service.remove(`/subscription-plans/delete/${id}`);

  if (response.status === 200) {
    return response.data;
  }

  return undefined;
};

export const getDefaultPermissions = async () => {
  const response = await serviceTwo.getTwo(`/custom-roles/get-default-permissions`);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getPlans,
  getPlan,
  getPlanMenu,
  createPlan,
  updatePlan,
  remove,
  getDefaultPermissions,
};
